module.exports = __webpack_public_path__ + "img/section-solution-2.460ad3f3.png";